import BaseCellHandler from './BaseCellHandler';
import CommentWrapper from '@/views/storyboard/charts/comment/CommentWrapper';
import {AdditionalFilter, AllFields} from 'entities/chartFilters';


class CommentCellHandler extends BaseCellHandler {
    endpointUrl = null;

    // eslint-disable-next-line class-methods-use-this
    protected loadData = async (
        debounce = true,
        globalFields: AllFields,
        globalFilters: AdditionalFilter[],
    ): Promise<void> => {
        // no-op
    }

    render() {
        const {chartQuery, chartTitle} = this.props;

        return (
            <CommentWrapper queryData={chartQuery?.additionalData} chartTitle={chartTitle} />
        );
    }
}

export default CommentCellHandler;
